import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";

import { ProductCompareTheme } from "../../../constants";
import { IAttributeOptionGroup } from "../../../models/product-compare.interfaces";
import { TDispatchMapper, TStateMapper } from "../../reducers.interfaces";
import { SizeSelector as SizeSelectorComponent } from "../components/ProductCompareSizeSelector";
import { defaults } from "../defaults";
import { Dispatchers } from "../dispatchers";

import styles from "./ProductCompareSizeSelector.module.scss";

interface IOwnProps {
    sizeAttributeOptionGroup: IAttributeOptionGroup;
    preselectedSize: string | null;
    showSizeSelector?: boolean | null;
    theme?: ProductCompareTheme | null;
}

interface IReduxProps {
    priceSelectValue: string;
}

interface IDispatchProps {
    dispatchers: Dispatchers;
}

interface IProps extends IOwnProps, IDispatchProps, IReduxProps {}

interface IState {}

// TODO(ssr, LEVEL 6 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 6/10 due to componentDidMount with localStorage access, Redux connect, and state synchronization logic.
class SizeSelectorContainer extends React.Component<IProps, IState> {
    private readonly onSelectChange = (
        e: React.ChangeEvent<HTMLSelectElement>,
    ) => {
        // Update size select value
        this.props.dispatchers.updatePriceSelectValue(e.currentTarget.value);
        localStorage.setItem("selectedSize", e.currentTarget.value);
    };

    componentDidMount() {
        if (this.props.preselectedSize) {
            this.props.dispatchers.updatePriceSelectValue(
                this.props.preselectedSize,
            );
        } else {
            // fetch the size attribute from localStorage
            // and set it only if preselectedSize is not defined
            const selectedSize: string | null =
                localStorage.getItem("selectedSize");
            if (selectedSize) {
                this.props.dispatchers.updatePriceSelectValue(selectedSize);
            }
        }
    }

    render() {
        if (!this.props.showSizeSelector) {
            return null;
        }

        const rootClassNames = classNames({
            [styles.root]: true,
            [this.props.theme || ""]:
                this.props.theme === ProductCompareTheme.THEME_ONE,
        });

        return (
            <div className={rootClassNames}>
                <SizeSelectorComponent
                    sizeAttributeOptionGroupName={
                        this.props.sizeAttributeOptionGroup.name
                    }
                    sizeAttributeOptions={
                        this.props.sizeAttributeOptionGroup.options
                    }
                    priceSelectValue={this.props.priceSelectValue}
                    onSelectChange={this.onSelectChange}
                />
            </div>
        );
    }
}

const mapStateToProps: TStateMapper<
    "productcompare",
    IReduxProps,
    IOwnProps
> = (rootState, ownProps) => {
    const state = rootState.productcompare || defaults;
    return {
        ...ownProps,
        priceSelectValue: state.priceSelectValue,
    };
};

const mapDispatchToProps: TDispatchMapper<IDispatchProps> = (dispatch) => {
    const dispatchers = new Dispatchers(dispatch);
    return {
        dispatchers: dispatchers,
    };
};

export const SizeSelector = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SizeSelectorContainer);
